import { put, takeEvery } from "redux-saga/effects"
import { GET_POPUP_SETUP, ADD_POPUP_SETUP } from "store/popup/actionTypes"
import {
  getPopupSetup,
  getPopupSetupSuccess,
  addPopupSetupSuccess,
} from "store/popup/actions"
import { post, get } from "helpers/api_helper"
import * as url from "helpers/url_helper"
import { getFormDataFromJSON } from "utils"
import { showToast } from "../../utils"

function* getPopupSetupSaga({ payload: { params } }) {
  try {
    const response = yield get(url.POPUP_SETUP_URL)
    yield put(getPopupSetupSuccess(response))
  } catch (error) {
    yield put(apiError(error))
    showToast("error", error, "Error")
  }
}

function* addPopupSetupSaga({ payload: { values } }) {
  let formData = getFormDataFromJSON(values)
  try {
    const response = yield post(url.POPUP_SETUP_URL, formData)
    yield put(addPopupSetupSuccess(response))
    showToast("success", "The popup has been saved!", "Success")
  } catch (error) {
    yield put(apiError(error))
    showToast("error", error, "Error")
  }
}

function* popupSaga() {
  yield takeEvery(GET_POPUP_SETUP, getPopupSetupSaga)
  yield takeEvery(ADD_POPUP_SETUP, addPopupSetupSaga)
}

export default popupSaga
